// toastSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ToastState {
  show: boolean;
  message: string;
  severity: "success" | "error" | "warning" | "information";
  actionLabel?: string;
  handleAction?: () => void;
  handleClose?: () => void;
  position?: string;
}

const initialState: ToastState = {
  show: false,
  message: "",
  severity: "information",
  actionLabel: "Action",
  handleAction: undefined,
  handleClose: undefined,
  position: "bottom",
};

const toastSlice = createSlice({
  name: "toast",
  initialState,
  reducers: {
    showToast: (
      state,
      action: PayloadAction<
        Omit<ToastState, "show"> & {
          handleAction?: () => void;
          handleClose: () => void;
        }
      >,
    ) => {
      state.show = true;
      state.message = action.payload.message;
      state.severity = action.payload.severity;
      state.actionLabel = action.payload.actionLabel;
      state.handleAction = action.payload.handleAction;
      state.handleClose = action.payload.handleClose;
      state.position = action.payload.position || "bottom";
    },
    hideToast: (state) => {
      state.show = false;
      state.message = "";
      state.severity = "information";
      state.actionLabel = "Action";
      state.handleAction = undefined;
      state.handleClose = undefined;
      state.position = "bottom";
    },
  },
});

export const { showToast, hideToast } = toastSlice.actions;
export default toastSlice.reducer;
